import React from 'react';

import { GRAY_50_HEX } from 'shared';
import Clickable from './Clickable';
import Icon from './Icon';
import Layout from './Layout';
import Text from './Text';

export type TagStyle = 'default' | 'outline';

export type TagTextSize = 'body-xs' | 'body-sm' | 'body-md' | 'body-lg' | 'body-xl';

interface Props {
  value: string;
  onRemove: () => void;
  /** When false, hides the remove (X) icon. Default: true. */
  removable?: boolean;
  /** "outline" = white background + gray-50 1px border (Tag Outline). Default: "default". */
  tagStyle?: TagStyle;
  /** Text size inside the tag. Default: "body-md". */
  textSize?: TagTextSize;
}

const Tag: React.FC<Props> = ({
  value,
  onRemove,
  removable = true,
  tagStyle: styleVariant = 'default',
  textSize = 'body-md'
}) => {
  const isOutline = styleVariant === 'outline';

  return (
    <Layout
      paddingLeft={10}
      paddingRight={removable ? 8 : 10}
      paddingY={1}
      flex
      color={isOutline ? 'white' : 'gray-50'}
      borderRadius={1000}
      align="center"
      {...(isOutline ? { __style: { border: `1px solid ${GRAY_50_HEX}` } } : {})}
    >
      <Text size={textSize} color="gray-900" semibold>
        {value}
      </Text>
      {removable && (
        <Clickable onClick={() => onRemove()} style={{ marginLeft: 2, display: 'inline-flex' }}>
          <Icon name="close" color="gray-900" size="xs" />
        </Clickable>
      )}
    </Layout>
  );
};

export default Tag;
